<!--
    校区管理-学生管理-生成学生二维码
    功能：二维码方式学生绑定手机号
    组件: el-tabs
-->
<template>
  <div
    v-loading="loading"
    class="wrapper">
    <!-- <image src="circleUrl"/> -->
    <!-- <el-image
      :src="circleUrl"
      class="code"/> -->
    <canvas
      ref="studentCode"
      width="250"
      height="443"/>
    <div
      id="qrCode"
      style="display: none"/>
    <div class="info">分享二维码给学生家长，进行绑定学生手机号， 接收学生上课/课后练习等信息</div>
    <div class="bottom">
      <el-button @click="handlerClose">取 消</el-button>
      <el-button
        :loading="downLoading"
        type="primary"
        @click="handlerDown"
      >下 载</el-button>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import FileSaver from 'file-saver';
import QRCode from 'qrcodejs2';
import h5Url from '@/utils/h5Url';

export default {
  name: 'StudentCode',
  props: {
    studentInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      downLoading: false,
      codeBg: require('@/assets/images/student_code_bg.png'),
    };
  },
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      const data = {
        school: this.$store.state.choicesSchool.name,
        teacher: this.$store.state.user.name,
        student_num: this.studentInfo.number,
        student_name: this.studentInfo.name,
        student_code: this.studentInfo.student_code,
      };
      this.setCanvas(data);
    }, 500);
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    // 绘制图片
    setCanvas(data) {
      const qrUrl = `${h5Url}/class_code/bind?studentCode=${data.student_code}`;
      new QRCode('qrCode', {
        text: qrUrl,
        width: 700,
        height: 700,
        colorDark: '#333333',
        colorLight: '#ffffff',
        // correctLevel: QRCode.CorrectLevel.H,
        correctLevel: 0,
      });
      const myCanvas = document.getElementById('qrCode').getElementsByTagName('canvas')[0];
      const codeUrl = myCanvas.toDataURL('image/png');
      const canvas = this.$refs.studentCode;
      canvas.width = 250;
      canvas.height = 443;
      const ctx = canvas.getContext('2d');
      const bgImg = new Image();
      bgImg.src = this.codeBg;
      bgImg.onload = () => {
        ctx.drawImage(bgImg, 0, 0, 752, 1334, 0, 0, 250, 443);
        this.canvasText(canvas, ctx, data.school, '600 15px sans-serif', '#FFEFA4', 0, 40, 'center');
        this.canvasText(canvas, ctx, `${data.teacher}老师邀请您`, '12px  sans-serif', '#ffffff', 0, 65, 'center');
        this.canvasText(canvas, ctx, '绑定/修改学生手机号', '12px  sans-serif', '#ffffff', 0, 82, 'center');
        const qrImg = new Image();
        qrImg.src = codeUrl;
        qrImg.onload = () => {
          ctx.drawImage(qrImg, 71.5, 139, 110, 110);
          this.canvasText(canvas, ctx, '学号', '600 10px  sans-serif', '#999999', 70, 361);
          this.canvasText(canvas, ctx, data.student_num, '600 10px  sans-serif', '#000000', 130, 361);
          this.canvasText(canvas, ctx, '姓名', '600 10px  sans-serif', '#999999', 70, 392);
          this.canvasText(canvas, ctx, data.student_name, '600 10px  sans-serif', '#000000', 130, 392);
        };
      };
    },
    canvasText(canvas, ctx, text, fontSzie, color, width, height, align) {
      ctx.font = fontSzie;
      ctx.fillStyle = color;
      if (align === 'center') {
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, canvas.width / 2, height);
      } else {
        ctx.fillText(text, width, height);
      }
    },
    // 下载图片
    handlerDown() {
      this.downLoading = true;
      const canvas = this.$refs.studentCode;
      html2canvas(canvas, {
        backgroundColor: null,
        useCORS: true, // 允许图片跨域
        taintTest: true, // 在渲染前测试图片
        timeout: 500, // 加载延时
      }).then((item) => {
        item.toBlob((blob) => {
          FileSaver.saveAs(blob, `${this.studentInfo.name}学生码.jpeg`);
        });
        this.downLoading = false;
      });
    },
    handlerClose() {
      this.$emit('close-dialog');
    },
  },
};
</script>

<style  lang="scss" scoped>
.wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
}
  .code{
    width: 160px;
    height: 160px;
    padding: 6px;
    border:2px solid #DDDFE7
  }
  .info{
    margin-top: 15px;
    width: 300px;
    line-height: 20px;
    text-align: center;
    color: #909399;
  }
   .bottom{
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/Student/components/BindPhoneDialog/studentCode.vue